import PhotoMotion from '@/components/feature/PhotoMotion';
import { cdn } from '@/config/cdn';

export default function StoryHero() {
  return (
    <section data-nav-dark className="bg-[#171515] text-[#F5F1EB] pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden" aria-labelledby="story-heading">
      <div className="fold-shell">
        <div className="flex items-baseline justify-between gap-6 border-b border-[rgba(245,241,235,0.14)] pb-5">
          <p className="fold-label text-[rgba(245,241,235,0.6)]">Our Story / FOLD.</p>
          <p className="fold-label text-[rgba(245,241,235,0.6)] hidden sm:block">Made by hand, one morning at a time</p>
        </div>

        <div className="mt-10 md:mt-16 grid grid-cols-1 lg:grid-cols-12 gap-y-10 lg:gap-x-8">
          <div className="lg:col-span-5 min-w-0 flex flex-col justify-between order-2 lg:order-1">
            <h1 id="story-heading" className="fold-serif uppercase leading-[0.88] tracking-[-0.035em] text-[15vw] sm:text-[11vw] lg:text-[6.4vw] xl:text-[6.6rem]">
              The art<br />of taking<br /><span className="italic">time.</span>
            </h1>
            <div className="mt-10 lg:mt-0 max-w-[340px] border-l border-[rgba(245,241,235,0.2)] pl-6">
              <p className="fold-serif text-xl md:text-[22px] leading-snug">Every layer begins with patience.</p>
              <p className="mt-3 text-[15px] leading-relaxed text-[rgba(245,241,235,0.65)]">Every bake, with a little more care.</p>
            </div>
          </div>

          <figure className="lg:col-span-7 min-w-0 order-1 lg:order-2">
            <div className="w-full aspect-[4/5] sm:aspect-[5/4] lg:aspect-[6/7] overflow-hidden bg-[#0f0e0e]">
              <PhotoMotion fromScale={1.045} fromY={18} duration={1.25} delay={0.1}>
              <img
                src={cdn('https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_story-hero.webp')}
                alt="A baker folding laminated dough by hand"
                title="Folding laminated dough — FOLD. Artisan Bakery"
                className="w-full h-full object-cover object-[50%_45%]"
              />
              </PhotoMotion>
            </div>
            <figcaption className="mt-3 flex justify-between gap-4 fold-label text-[rgba(245,241,235,0.5)]">
              <span>Fig. 01</span><span>The first fold</span>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}